import { ItemList } from 'orm'

class KpiTemplateList extends ItemList {
    getEntityKey() {
        return "admin/kpi_template"
    }
}

export const adminKpiTemplateList = new KpiTemplateList("admin_kpi_template__default")
